import React, {useState} from "react";
import {Ajax} from "../Service/ajax";
import {useNavigate, useParams} from "react-router-dom";
import Swal from "sweetalert2";
import SubscriptionForm from "./FormInputs/SubscriptionForm";

export default function Card2({devise, price, periodicity, title, description,options, subscription,cmp,convertedAmount=null}){
    let period;
    let currency;
    const session = sessionStorage.getItem("session");
    const navigate = useNavigate();
    const [showSecondModal, setShowSecondModal] = useState(false);
    const { pageUrl } = useParams();

    const fetchData = async ()=>{
        try {
            const {data} = await Ajax.postRequest("/api/v1/sub/subscription/"+subscription.id+"/subscribe", []);
            if(data.error){
                const url = window.location.pathname + window.location.search;
                navigate("/payment-check", { state: { errors: url } });
            }else{
                const {object} = data;
                navigate("/payment-check", { state: { success: JSON.stringify(object) } });
            }
        }catch (error){
            const url = window.location.pathname + window.location.search;
            navigate("/payment-check", { state: { errors: url } });
        }
    }
    const handleNavigation = () => {
        if(session) {
            if(subscription.price > 0){
                subscription["cmp"]=cmp;
                navigate("/payment", { state: { someData: JSON.stringify(subscription) } });
            }else{
                fetchData();
            }
        } else {
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login/?target=subs")
            }else{
                navigate(`/login?target=own-page&target_id=${pageUrl}`);
            }
        }
    };

    const handleAccept = () => {
        if (subscription.infos.length === 0) {
            handleNavigation();
        } else {
            setShowSecondModal(true);
        }
    };

    const handleSecondModalClose = () => {
        setShowSecondModal(false);
    };
    const handleSubscribe = () => {
        if(session) {
            Swal.fire({
                title: 'Message important',
                text: "Vous êtes sur le point de vous abonner à ce service. Soyez rassurés que toute  information personnelle qui vous sera demandée sera gardée privée et traitée conformément à notre politqie de confidentialité !",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor:'#debf66',
                focusConfirm:true,
                confirmButtonText: 'Continuer',
                cancelButtonText:'Annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    handleAccept();
                }
            })
        }else{
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login?target=subs")
            }else{
                navigate(`/login?target=own-page&target_id=${pageUrl}`);
            }
        }
    }
    function formatPrice(price) {
        if (isNaN(price) || price === null || price === undefined) {
            return '0.00';
        }
        return parseFloat(price)
            .toLocaleString('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            .replace(',', '.');
    }


    switch (devise){
        case 'USD':
            currency = "$";
            break;
        case 'CDF':
            currency = "CDF ";
            break;
        default:
            currency = null;
    }
    switch (periodicity) {
        case 'DAILY':
            period = "Jour";
            break;
        case 'WEEKLY':
            period = "Semaine";
            break;
        case 'MONTHLY':
            period = "Mois";
            break;
        case 'ANNUAL':
            period = "Année";
            break;
        case 'PERMANENT':
            period = "À vie";
            break;
        default:
            period = null;
    }
    return(
        <div className="col-md-9 col-lg-3 mb-3">
            <div className="card h-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title m-0 me-2">Pack {title}</h5>
                </div>
                {price > 0 ?
                    <div className="card-body">
                        <p className="mb-4 h-px-50">Abonnez-vous dès maintenant pour profiter des avantages de notre
                            plan {title} .</p>
                        <div className="d-flex border-primary p-2 border rounded mb-4">
                            <div className="d-flex flex-column w-100 gap-2">
                                <div className="me-2">
                                    <p className="mb-0">{title}</p>
                                    {convertedAmount ? (
                                        <p className="fs-4" data-bs-toggle="modal">${convertedAmount}</p>
                                    ) : null}
                                </div>
                                <div className="user-progress">
                                    <div className="d-flex justify-content-end">
                                        <h4 className="mb-0">
                                            {currency}
                                            {formatPrice(price)}
                                        </h4>
                                        <sub className="mt-auto mb-2"> /{period}</sub>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/*<div className="pt-2">*/}
                        {/*    <h6 className="mb-4">{description}</h6>*/}
                        {/*    {options.map((item, index) => (*/}
                        {/*        <div key={index} className={"d-flex mb-1"}>*/}
                        {/*            <div className="d-flex justify-content-between w-100 flex-wrap gap-2">*/}
                        {/*                <div className="d-flex w-px-100">*/}
                        {/*                    <h6 className={`mb-0 ${item.option.length > 10 ? 'truncate' : ''}`}>*/}
                        {/*                        {item.option}*/}
                        {/*                    </h6>*/}
                        {/*                </div>*/}
                        {/*                <div className="w-px-100">*/}
                        {/*                    <h6 className="mb-0">{item.value}</h6>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}

                        {/*        </div>*/}

                        {/*    ))}*/}
                        {/*</div>*/}
                    </div> :
                    <div className="card-body">
                        <p className="mb-4 h-px-50">Essaie dès maintenant notre plan d'essaie{}</p>
                        <div className="d-flex border-primary p-2 border rounded mb-4">
                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div className="me-2">
                                    <p className="mb-0">{title}</p>
                                    <p className="small" data-bs-toggle="modal">Pack</p>
                                </div>
                                <div className="user-progress">
                                    <div className="d-flex justify-content-center">
                                        <sup className="mt-3 mb-0 me-1">{currency}</sup>
                                        <h3 className="mb-0">{price}</h3>
                                        <sub className="mt-auto mb-2"> /{period}</sub>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div className="pt-2">*/}
                        {/*    <h6 className="mb-4">{description}</h6>*/}
                        {/*    {options.map((item, index) => (*/}
                        {/*        <div key={index} className={"d-flex mb-1"}>*/}
                        {/*            <div className="d-flex justify-content-between w-100 flex-wrap gap-2">*/}
                        {/*                <div className="d-flex w-px-100">*/}
                        {/*                    <h6 className={`mb-0 ${item.option.length > 10 ? 'truncate' : ''}`}>{item.option}</h6>*/}
                        {/*                </div>*/}
                        {/*                <div className="w-px-100">*/}
                        {/*                    <h6 className="mb-0">{item.value}</h6>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}

                        {/*    ))}*/}
                        {/*</div>*/}
                    </div>
                }
                <div className="col-12 text-center mb-3">
                    {subscription.price > 0 ?
                        <button
                            type="button"
                            className="btn btn-netikash"
                            onClick={handleSubscribe}
                        >
                            S'ABONNER
                        </button> :
                        <button
                            type="button"
                            className="btn btn-netikash"
                            onClick={handleSubscribe}
                        >
                            Essayer Maintenant
                        </button>
                    }
                </div>
            </div>
            {showSecondModal && (
                <div className="modal fade show" id={subscription.id} tabIndex="-1" aria-modal="true" data-bs-backdrop="static" data-bs-keyboard="false" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-fullscreen" role="document">
                        <SubscriptionForm title={subscription.title} subscription={subscription} cmp={cmp} onCloseModal={handleSecondModalClose}/>
                    </div>
                </div>
            )}
        </div>
    );
}